<template>
  <div
    class="auto-layout-component"
    :class="isDragover ? 'isDrag-over' : ''"
    :id="'auto-layout-component' + Object.values(myid).join('')"
    @click.stop.prevent="clickAutoLayoutBox"
    @drop.stop="handleAutoLayoutDragover($event)"
    @dragover.stop.prevent="dragoverEv"
    @dragleave.prevent="dragoverLeaveEv"
    :ref="'auto-layout-component' + Object.values(myid).join('')"
    :style="containerStyle"
    >
    <p class="emptyColText" v-if="options.elementOptions.length === 0 && layoutSize">从左侧工具栏拖拽添加组件</p>
    <div
      class="auto-layout-content scroller"
      :class="[
        options.rowColDirection !== 'horizon' ? 'vertical' : 'horizon',
        options.showRowColLayout ? 'row-col-layout' : '']"
      :ref="'auto-layout-content' + Object.values(myid).join('')"
      :style="{...getAutoLayoutContentStyle,...getOverStyle}"
    >
      <vueDragResizable
        ref="autoLayoutElement"
        v-for="(elementOption, index) in options.elementOptions"
        v-show="display(elementOption)"
        :key="'layoutComponent' + elementOption.elementInAutoLayoutId "
        :data-innerElement="'element is:' + elementOption.innerElement"
        :parent="true"
        :zoom="zoom"
        :options="elementOption"
        :rectId="myid.rect_id"
        :shape="elementOption.innerElement"
        :elementInAutoLayoutId="elementOption.elementInAutoLayoutId"
        :elementName="elementOption.innerElement"
        :active="elementOption.active && !isElementInLayout"
        :parentW="Number(getParentW)"
        :parentH="Number(getParentH)"
        :w="elementOption.width"
        :h="elementOption.height"
        :x="0"
        :y="0"
        v-on:dragStart="dragstartEv"
        v-on:dragging="draggingEv"
        v-on:dragStop="dragstopEv"
        v-on:resizing="resizingEv"
        v-on:resizeStop="resizestopEv($event, elementOption.elementInAutoLayoutId, elementOption.path)"
        v-on:activated="activeEv(elementOption.elementInAutoLayoutId, elementOption.innerElement, elementOption, index)"
        v-on:delElement="delElementEv(elementOption.elementInAutoLayoutId, elementOption.path)"
        :class="[
          myid.uid ? `container_id_${myid.container_id}-rect_id_${myid.rect_id}-uid_${myid.uid}-elementInLayoutId_${elementOption.elementInLayoutId}-elementInAutoLayoutId_${elementOption.elementInAutoLayoutId}-path_${elementOption.path ? elementOption.path.join('') : elementOption.path}` : `container_id_${myid.container_id}-rect_id_${myid.rect_id}-elementInAutoLayoutId_${elementOption.elementInAutoLayoutId}-path_${elementOption.path ? elementOption.path.join('') : elementOption.path}`,
          elementOption.active && !isElementInLayout ? 'active' : '',
          isDragover && insertIndex - 1 === index && (insertIndex - 1 > activeIndex || currentHalf) ? 'ghost after' : isDragover && insertIndex - 1 === index && (insertIndex - 1 < activeIndex || !currentHalf) ? 'ghost before' : ''
        ]"
        @click.stop.prevent
        @mouseup.stop.prevent
        @mousedown.stop.prevent
        :resizable="true"
        :draggable="true"
        :handles="checkHandles(elementOption)"
        :myId="{ ...myid, elementInAutoLayoutId: elementOption.elementInAutoLayoutId, path: elementOption.path  }"
        :style="getVdrStyle"
      >
        <div
          class="vdr_shade"
          :class="elementOption.leftType === '%' || elementOption.topType === '%' ? 'no-drag' : ''"
          v-if="
            (!elementOption.active && complexComponents.includes(elementOption.innerElement) && !isElementInLayout) || (isDragover && insertIndex - 1 === index && elementOption.innerElement === 'cxAutoLayout')
          "
        ></div><!-- 复杂组件激活状态打开设置项才能选中子组件 -->
        <component
          class="rect"
          :options="elementOption"
          :myid="{ ...myid, elementInAutoLayoutId: elementOption.elementInAutoLayoutId, path: elementOption.path}"
          :is="elementOption.innerElement"
        >
        </component>
      </vueDragResizable>
    </div>
  </div>
</template>

<script>
import { _debounce, _throttle, deepChangeUid, isExist } from "utils/index"
import { materialLoader } from "core/materialLoader"
import animateMixin from "utils/event/animateMixin.js"
import vueDragResizable from "components/publicComponent/vueDragRiseable/vue-drag-resizable.vue"
import componentsMixin from "./componentsMixin.js"
import { getFirstModuleEncId, getSyetemModuleJson } from "@/utils/initEv.js"
import draggable from "vuedraggable"
import VueGridLayout from 'vue-grid-layout';
import dataRenderMixin from "materials/dataRenderMixin"

export default {
  mixins: [componentsMixin, animateMixin, dataRenderMixin],
  name: "cxAutoLayout",
  components: {
    ...materialLoader.getRenderComponentsMixin([
      "cxButton",
      "cxText",
      "cxLabel",
      "cxNavMenuVertical",
      "cxNavMenu",
      "cxTabs",
      "cxPagination",
      "cxBreadCrumbs",
      "imageComponent",
      "cxIcon",
      "cxHomeLine",
      "cxVerticalLine",
      "cxEditor",
      "cxAudio",
      "cxMultiFilter",
      "layoutComponent",
      "emptyLayoutComponent",
      "cxAnchorComponent"
    ]),
    GridLayout: VueGridLayout.GridLayout,
    GridItem: VueGridLayout.GridItem,
    vueDragResizable,
    draggable
  },
  props: {
    options: {
      type: Object,
      default: null
    },
    myid: {
      type: Object,
      default: null
    },
    zoom: {
      type: Number,
      default: 1
    },
    rect: {
      type: Object
    }
  },
  data() {
    return {
      // getParentW: Infinity,
      // getParentH: Infinity,
      isDragover: false,
      activeIndex: -1, // 激活组件
      insertIndex: null, // 插入组件
      dragging: false, //拖拽中
      resizeOb: null,
      layoutSize: true,
      complexComponents: ["emptyLayoutComponent", "swiperComponent", "cxDataGrid"],
      currentHalf: false, //当前位置是否超过当前元素的一半
    }
  },
  mounted() {
    const el = this.$refs["auto-layout-content" + Object.values(this.myid).join('')]
    // if (el && el.offsetWidth !== 0) this.getParentW = el.offsetWidth
    // if (el && el.offsetHeigh !== 0) this.getParentH = el.offsetHeight
    // 监听当前自动布局尺寸的改变
    this.watchResize()
    // const resizeObserver = new ResizeObserver(entries => {
    //   for (let entry of entries) {
    //     console.log('entry :>>',entry);
    //     this.getWidth = entry.target.offsetWidth
    //     this.getHeight = entry.target.offsetHeight
    //   }
    // })
    // resizeObserver.observe(el);
  },
  beforeDestroy() {
    this.resizeOb && this.resizeOb.unobserve(this.$el)
  },
  watch: {},
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    display() {
      return rect => {
        const shape = ["cxDataGrid", "cxNoteEditor", "cxPagination"]
        if (shape.includes(rect.innerElement) && rect.hasOwnProperty("isShow")) {
          return rect.isShow;
        } else {
          return true
        }
      }
    },
    // layoutSize() {//高度小于40 宽度小于200px不显示提示文字
    //   let height = parseInt(this.options?.height)
    //   let width = parseInt(this.options?.width)
    //   if (this.options?.heightType !== "px") {
    //     height = this.getHeight
    //   }
    //   if (this.options?.widthType !== "px") {
    //     width = this.getWidth
    //   }
    //   if (height < 40 || width < 200) return false
    //   return true
    // },
    isElementInLayout() {
      let rect = this.getAttrById(this.$store.state[this.request_prefix], this.ids, "rect")
      if (rect && rect.shape === "emptyLayoutComponent") {
        return false
      }
      if (this.ids.uid) {
        return true
      }
      if (this.ids.elementInLayoutId !== null && typeof this.ids.elementInLayoutId !== "undefined") {
        return true
      }
      if (this.ids.elementInSwiperId !== null && typeof this.ids.elementInSwiperId !== "undefined") {
        return true
      }
      return false
    },
    getParentW() {
      let paddingLeftRight = this.options.padding * 2
      if (this.options.paddingTypeFlag === 2) {
        paddingLeftRight = this.options.paddingLeft + this.options.paddingRight
      }
      let boundWidth = this.options.boundHeight
      if (this.$el) {
        boundWidth = this.$el?.getBoundingClientRect()?.width / this.zoom
      }
      if (this.options.widthType && (this.options.widthType === "自动" || this.options.widthType === "%")) {
        return boundWidth - Number(paddingLeftRight)
      } else {
        return this.options.width - Number(paddingLeftRight)
      }
    },
    getParentH() {
      let paddingTopBottom = this.options.padding * 2
      if (this.options.paddingTypeFlag === 2) {
        paddingTopBottom = this.options.paddingTop + this.options.paddingBottom
      }
      let boundHeight = this.options.boundHeight
      if (this.$el) {
        boundHeight = this.$el?.getBoundingClientRect()?.height / this.zoom
      }
      if (this.options.heightType && (this.options.heightType === "自动" || this.options.heightType === "%")) {
        return boundHeight - Number(paddingTopBottom)
      } else {
        return this.options.height - Number(paddingTopBottom)
      }
    },
    themeColor() {
      return this.$store.state[this.request_prefix].page.themeColor
    },
    boxShadowStyle() {
      let tmpStyle = ""
      let _this = this
      if (Array.isArray(this.options.boxShadowH)) {
        this.options.boxShadowH.forEach((item, index) => {
          if (index > 0) {
            tmpStyle += ","
          }
          tmpStyle +=
              `${_this.options.boxShadowH[index]}px ${_this.options.boxShadowV[index]}px ${_this.options.boxShadowBlur[index]}px ${_this.options.boxShadowSpread[index]}px ${_this.$parseColor(_this.options.boxShadowColor[index])}`
        })
      } else {
        tmpStyle +=
            `${this.options.boxShadowH}px ${this.options.boxShadowV}px ${this.options.boxShadowBlur}px ${this.options.boxShadowSpread}px ${this.$parseColor(this.options.boxShadowColor)}`
      }
      return tmpStyle
    },
    getPaddingStyle() {
      let padding = `${this.options.padding}px`
      if (this.options.paddingTypeFlag === 2) {
        padding = ` ${this.options.paddingTop}px  ${this.options.paddingRight}px  ${this.options.paddingBottom}px  ${this.options.paddingLeft}px`
      }
      return padding
    },
    bgStyle() {
      let containerBg = {
        backgroundImage: ""
      }
      let curBackground = this.options.background
      if (
        !curBackground ||
        !Array.isArray(curBackground) ||
        (Array.isArray(curBackground) && curBackground.length === 0)
      ) {
        curBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.options.hasOwnProperty("bgColorIsThemeColor") ? this.options.bgColorIsThemeColor : false,
            color: this.options.bgColor
          }
        ]
      }
      curBackground.forEach(bg => {
        switch (bg.type) {
          case "img":
            let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
            if (bg.imgUrl) {
            containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
              containerBg.backgroundImage = this.setBorderColor("",containerBg.backgroundImage)
            }
            containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},${bg.clipSize}`:`${bg.clipSize}`
            containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},${bg.alignType}`:`${bg.alignType}`
            containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},${bg.repeatType}`:`${bg.repeatType}`
            break
          case "color":
            containerBg.backgroundColor = this.$parseColor(bg)
            containerBg.backgroundImage = this.setBorderColor(containerBg.backgroundColor,containerBg.backgroundImage)
            break
          case "linearGradient":
            // let tmp = []
            if (bg.data.stops.length > 0) {
              // bg.data.stops.forEach(item => {
              //   tmp.push(item[0] + " " + item[1] * 100 + "%")
              // })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage += dot + "linear-gradient(" + bg.data.angle + "deg," + tmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundImage = this.setBorderColor("",containerBg.backgroundImage)
              containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},auto`:`auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},center`:`center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},no-repeat`:`no-repeat`
            }
            break
          case "radialGradient":
            // let radialTmp = []
            if (bg.data.stops.length > 0) {
              // bg.data.stops.forEach(item => {
              //   radialTmp.push(item[0] + " " + item[1] * 100 + "%")
              // })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              // containerBg.backgroundImage +=
              //   dot + "radial-gradient(at " + bg.data.siteX + "% " + bg.data.siteY + "%," + radialTmp.join(",") + ")"
              containerBg.backgroundImage = this.setBorderColor("",containerBg.backgroundImage)
              containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},auto`:`auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},center`:`center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},no-repeat`:`no-repeat`
            }
            break
          default:
        }
      })
      if (this.options.showBorder !== false && this.isGradientBorder(this.options.borderColor, this.options.borderIsThemeColor)) {
        containerBg.backgroundClip = "padding-box,border-box"// 圆角裁切
        containerBg.backgroundOrigin = "padding-box,border-box"
      }
      return containerBg
    },
    containerStyle() {
      if (this.options) {
        let borderW = ""
        if (Array.isArray(this.options.borderWidth)) {
          this.options.borderWidth.forEach(item => [(borderW += ` ${item}px`)])
        } else {
          borderW += ` ${this.options.borderWidth}px`
        }
        let maxWidth = ""
        let minWidth = ""
        let maxHeight = ""
        let minHeight = ""
        if (this.options.showRowColLayout) {
          /* 自动布局 */
          let options = this.options
          maxWidth = options.showMaxWidth ? options.maxWidth + "px" : ""
          minWidth = options.showMinWidth ? options.minWidth + "px" : ""
          maxHeight = options.showMaxHeight ? options.maxHeight + "px" : ""
          minHeight = options.showMinHeight ? options.minHeight + "px" : ""
        }
        return {
          ...this.bgStyle,
          opacity: this.options.opacity / 100,
          "border-style": this.options.borderStyle,
          "border-color": this.isGradientBorder(this.options.borderColor, this.options.borderIsThemeColor) ? "transparent" :
              this.$parseColor(this.options.borderColor,{isThemeColor: this.options.borderIsThemeColor}),
          "border-width": this.options.showBorder !== false ? borderW : 0,
          "box-shadow": this.boxShadowStyle,
          "border-top-left-radius": this.options.borderTopLeftRadius + "px",
          "border-top-right-radius": this.options.borderTopRightRadius + "px",
          "border-bottom-left-radius": this.options.borderBottomLeftRadius + "px",
          "border-bottom-right-radius": this.options.borderBottomRightRadius + "px",
          padding: this.getPaddingStyle,
          "--maxWidth": maxWidth,
          "--minWidth": minWidth,
          "--maxHeight": maxHeight,
          "--minHeight": minHeight,
          outline: this.options?.elementOptions?.length > 0 ? "none" : "1px dashed var(--thirdTextColor)"
        }
      }
    },
    getAutoLayoutContentStyle(e) {
      if (!this.options?.showRowColLayout) return {}
      let alignItems = "start"
      let justifyContent = "start"
      let alignContent = "start"
      let style = {}
      let rowColDirection = this.options.rowColDirection
      switch (this.options.rowColAlignPositionH) {
        case "left":
          alignItems = "start"
          break
        case "center":
          alignItems = "center"
          break
        case "right":
          alignItems = "end"
          break
      }
      switch (this.options.rowColAlignPositionV) {
        case "top":
          justifyContent = "start"
          break
        case "middle":
          justifyContent = "center"
          break
        case "bottom":
          justifyContent = "end"
          break
      }
      if (rowColDirection === "horizon") {
        alignContent = justifyContent
      } else {
        alignContent = alignItems
      }
      /* 开启滚动后有滚动条的情况下 居中居右会显示不全 改为居左显示 */
      // let layout = document.getElementById(`auto-layout-component${Object.values(this.myid).join('')}`)
      // let contentHeight = layout?.getElementsByClassName("auto-layout-content")[0]?.scrollHeight
      // let contentWidth = layout?.getElementsByClassName("auto-layout-content")[0]?.scrollWidth
      // let vdrHeight = ""
      // let vdrWidth = ""
      // if (layout) {
      //   let padding = parseInt(this.options.padding) * 2
      //   if (this.options.paddingTypeFlag === 2) {
      //     if (rowColDirection === "horizon") {
      //       padding = parseInt(this.options.paddingTop) + parseInt(this.options.paddingBottom)
      //     } else {
      //       padding = parseInt(this.options.paddingLeft) + parseInt(this.options.paddingRight)
      //     }
      //   }
      //   vdrHeight = layout.getBoundingClientRect()?.height
      //   vdrHeight = vdrHeight - padding
      //   vdrWidth = layout.getBoundingClientRect()?.width
      //   vdrWidth = vdrWidth - padding
      // }
      // if (this.options.overFlowType === "scroll" || this.options.overFlowType === "auto") { // 开启滚动
      //   if (rowColDirection === "horizon") {
      //     if (contentWidth > vdrWidth) {
      //       alignItems = "start"
      //     }
      //   } else {
      //     if (contentHeight > vdrHeight) {
      //       justifyContent = "start"
      //     }
      //   }
      // }
      return {
        "border-top-left-radius": this.options.borderTopLeftRadius + "px",
        "border-top-right-radius": this.options.borderTopRightRadius + "px",
        "border-bottom-left-radius": this.options.borderBottomLeftRadius + "px",
        "border-bottom-right-radius": this.options.borderBottomRightRadius + "px",
        display: "flex",
        "align-content": this.options.autoWrap ? alignContent : "", //换行后显示格式
        "flex-direction": this.options.rowColDirection === "horizon" ? "row" : "column",
        "flex-wrap": this.options.autoWrap ? "wrap" : "nowrap", // 是否换行
        "align-items": this.options.rowColDirection === "horizon" ? justifyContent : alignItems,// 水平对齐格式
        "justify-content": this.options.marginType === "auto" ? "space-between" : this.options.rowColDirection === "horizon" ? alignItems : justifyContent, // 垂直对齐格式
        ...this.getMargin()
      }
    },
    // 溢出判断显示隐藏滚动
    getOverStyle() {
      let style = {}
      let overflow = ""
      if (this.options.overFlowType == "scroll") {
        overflow = "scroll"
      } else {
        overflow = this.options.overFlowType
      }
      let rowColDirection = this.options.rowColDirection
      if (rowColDirection === "horizon") {
        if (!this.options.autoWrap) {
          style = {
            "overflow-x": overflow ? overflow : "hidden",
            "overflow-y": overflow === "visible" ? "unset" : "hidden"
          }
        } else {
          style = {
            "overflow-y": overflow ? overflow : "hidden",
            "overflow-x": overflow === "visible" ? "unset" : "hidden"
          }
        }

      } else {
        if (!this.options.autoWrap) {
          style = {
            "overflow-y": overflow ? overflow : "hidden",
            "overflow-x": overflow === "visible" ? "unset" : "hidden"
          }
        } else {
          style = {
            "overflow-x": overflow ? overflow : "hidden",
            "overflow-y": overflow === "visible" ? "unset" : "hidden"
          }
        }

      }
      return style
    },
    getMargin() {
      return function () {
        let style = {}
        let marginBottom = "" //行布局为下边距 列布局为右边距
        let marginRight = "" //行布局为右边距 列布局为下边距
        if (this.options.showRowColLayout) {
          // 开启自动行列布局
          marginBottom = this.options.rowColMargin + "px"
          if (this.options.autoWrap) {// 开启自动换行
            marginRight = this.options.rowColMarginRight + "px"
          }
        }
        if (this.options.rowColDirection === 'horizon') {
          style.columnGap = this.options.marginType !== 'auto' ? marginBottom : ""
          style.rowGap = marginRight
        } else {
          style.rowGap = this.options.marginType !== 'auto' ? marginBottom : ""
          style.columnGap = marginRight
        }
        return style
      }
    },
    getVdrStyle() {
      return {
        // 取间距的一半，但是视觉上不在中间，所以+1
        "--custom-margin": this.options.marginType !== 'auto' && this.options.rowColMargin
            ? -(this.options.rowColMargin / 2 + 1) + "px"
            : 0
      }
    }
  },
  methods: {
    watchResize(maxTask = 0) {
      if (this.$el) {
        this.resizeOb = new ResizeObserver(
          _debounce(el => {
            let boundWidth, boundHeight
            if (el[0]?.contentRect) {
              boundWidth = el[0].contentRect.width
              boundHeight = el[0].contentRect.height
              /* 记录组件尺寸 当设置充满和自适应时需要 */
              this.$changeOptionsEV(boundWidth, "boundWidth", false)
              this.$changeOptionsEV(boundHeight, "boundHeight", false)
              if (Number(boundWidth) < 200 || Number(boundHeight) < 40) {//高度小于40 宽度小于200px不显示提示文字
                this.layoutSize = false
              } else {
                this.layoutSize = true
              }
            }
          }, 100)
        )
        this.resizeOb.observe(this.$el)
      } else if (maxTask < 10) {
        requestAnimationFrame(() => this.watchResize(maxTask + 1))
      } else {
        throw new Error("maxTask超出最大深度")
      }
    },
    clickAutoLayoutBox() {
      let thisIds = {
        ...this.myid,
        container_id: this.myid.container_id,
        rect_id: this.myid.rect_id,
        path: this.options.path,
        elementInAutoLayoutId: this.options.elementInAutoLayoutId
      }
      this.$store.dispatch(this.request_prefix + "/changeElementInAutoLayoutUnActive", thisIds)
      this.$store.commit("states/changeActiveID", thisIds)
      this.$store.commit("states/changeElementType", "cxAutoLayout")
    },
    activeEv(elementInAutoLayoutId, elementName, ele, index,e) {
      this.dragging = false // 鼠标按下时不算拖拽开始
      this.activeIndex = index
      console.log('this.myid :>>',this.myid,this.ids,elementName);
      let oldIds = JSON.parse(JSON.stringify(this.ids))
      if (isExist(oldIds.elementInAutoLayoutId)) {
        this.$store.dispatch(this.request_prefix + "/changeElementInAutoLayoutUnActive", oldIds)
      }
      if (isExist(oldIds.elementInLayoutId)) {
        // 在自由布局中
        this.clearAllActiveInCol()
      } else {
        if (isExist(oldIds.elementInAutoLayoutId)) {// 选中内部元素 取消其他元素的选中态
          this.$store.dispatch(this.request_prefix + "/changeElementInAutoLayoutUnActive", {
            container_id: this.ids.container_id,
            rect_id: this.ids.rect_id,
          })
        }
        // 取消外层选中态
        this.$store.dispatch(this.request_prefix + "/setActive", oldIds)
        this.$store.dispatch(this.request_prefix + "/unsetActive", oldIds)
      }
      if (isExist(oldIds.directionIndex)) {
        this.clearTitleOptActive(ele.path)
      }
      const activeID = {
        ...this.myid,
        elementInAutoLayoutId: elementInAutoLayoutId,
        path: ele.path
      }
      this.$store.commit("states/changeActiveID", activeID)
      const setNewActive = {
        ...this.myid,
        elementInAutoLayoutId: elementInAutoLayoutId,
        // option_name: "active",
        // option_val: true,
        path: ele.path,
        elementName: elementName
      }
      console.log('setNewActive :>>',setNewActive);
      console.log('elementName :>>',elementName);
      this.$store.dispatch(this.request_prefix + "/changeElementInAutoLayoutActive", setNewActive)
      this.$store.commit("states/changeElementType", elementName)
    },
    clearAllActiveInCol() {
      //清除单元格内元素的激活状态
      let param = {
        ...this.myid,
        option_name: "isActive",
        option_val: "delAllActive"
      }
      this.$store.dispatch(this.request_prefix + "/changeLayoutActive", param)
    },
    clearTitleOptActive(path) {
      let delAllTitleActive = {
        ...this.myid,
        elementInAutoLayoutId: this.ids.elementInAutoLayoutId,
        path: path
      }
      this.$store.dispatch(this.request_prefix + "/delAllLayoutTitleActive", delAllTitleActive)
    },
    resetRectAttrOpt(childItem, _attribute) {
      this.needHid = true
      let layoutUidMap = {}
      childItem.encId ? (_attribute.moduleId = childItem.encId) : ""
      childItem.typeId ? (_attribute.typeId = childItem.typeId) : ""
      // this.doAdd = true
      //鼠标移动处理
      if (this.request_prefix === "appStage" && _attribute.options.width > 414) {
        _attribute.options.width = 414
      }
      if (_attribute.shape === "layoutComponent" || _attribute.shape === "emptyLayoutComponent") {
        //递归修改uid 把menu里的默认uid（会导致cols的id值重复）修改为随机生成的uid
        layoutUidMap = deepChangeUid(_attribute)
      }
      _attribute.options.layoutUidMap = layoutUidMap
      return JSON.stringify(_attribute)
    },
    // 从菜单栏拖动组件到自动布局
    async handleAutoLayoutDragover(e) {
      console.log('拖入自动布局 :>>', this.myid);
      sessionStorage.setItem("isGridDragOver","true") // 禁止拖入栅格中
      sessionStorage.removeItem("dropOverCell")
      sessionStorage.removeItem("isDragging")
      this.insertIndex = null
      this.isDragover = false
      let rectAttr = e.dataTransfer.getData("rectAttribute")
      let childItemInfo = sessionStorage.getItem("childItemInfo")
      childItemInfo = JSON.parse(childItemInfo)
      if (!rectAttr || rectAttr.length === 0 || rectAttr === "undefined" || !JSON.parse(rectAttr).shape) {
        // 拖入的是系统样式
        if (childItemInfo.childItemName === "收藏") {
          rectAttr = JSON.parse(rectAttr)
          const _attribute = await getSyetemModuleJson(rectAttr.encId)
          rectAttr = JSON.stringify(_attribute)
        } else if (childItemInfo.childItemTypeId) { // 通过分类查找系统样式
          let childItem = await getFirstModuleEncId.call(this, childItemInfo.childItemTypeId)
          let attribute = childItem.content
          const _attribute = JSON.parse(JSON.stringify(attribute))
          rectAttr = this.resetRectAttrOpt(childItem, _attribute)
        } else {
          return
        }
      }
      rectAttr = JSON.parse(rectAttr)
      if (childItemInfo && childItemInfo.childItemTypeId) {
        rectAttr.options.componentTypeId = childItemInfo.childItemTypeId
        rectAttr.options.name = childItemInfo.childItemTitle ? childItemInfo.childItemTitle : childItemInfo.childItemName
        rectAttr.options.componentTypeName = childItemInfo.childItemTypeName
      }
      // 用于兼容以前收藏的样式中没shape的情况
      if (!rectAttr.shape && rectAttr?.options?.innerElement) {
        rectAttr.shape = rectAttr.options.innerElement
      }
      delete rectAttr.options.elementInLayoutId
      delete rectAttr.options.elementInSwiperId
      delete rectAttr.options.directionIndex
      let insertIndex = this.getInsertIndex(e)
      this.insertIndex = this.currentHalf ? insertIndex : insertIndex - 1
      insertIndex = this.insertIndex < 0 ? 0 : this.insertIndex
      if (this.myid.elementInAutoLayoutId !== null && typeof this.myid.elementInAutoLayoutId !== "undefined") {
        if (!this.options.path) {
          this.$set(this.options, "path", [])
        }
        rectAttr.options.path = JSON.parse(JSON.stringify(this.options.path))
        rectAttr.options.path.push(this.myid.elementInAutoLayoutId) // 当前父级布局的id
      }
      if (this.myid.elementInLayoutId !== null && typeof this.myid.elementInLayoutId !== "undefined") {
        rectAttr.options.elementInLayoutId = this.myid.elementInLayoutId
        // 当前组件在单元格中，不允许再拖入自由布局
        if (rectAttr?.options?.innerElement === "emptyLayoutComponent") return
      }
      //如果是自由布局组件 那就要检测自由布局组件内的组件是否有appid
      if (rectAttr.options.myFetchParam?.appId || rectAttr.options.appId) {
        //更新appid
        const appId = rectAttr.options.myFetchParam?.appId
          ? rectAttr.options.myFetchParam?.appId
          : rectAttr.options.appId
        // 需要判断当前组件类型，如果是基于自由布局开发的搜索组件/导航菜单，需要特殊处理
        const isSearchComponent = rectAttr.options.pluginName?.includes("searchComponentPlugin")
        const isNavComponent = rectAttr.shape.toLowerCase().includes("nav")
        await this.$styleToSaveModule("31CB73E03E24BBFF", "临时", appId, false, isSearchComponent, isNavComponent)
          .then(res => {
            if (!!res.appId) {
              // 没有myfetchparam的组件 比如搜索组件 更新appId
              rectAttr.options.appId = res.appId
              if (rectAttr?.options?.myFetchParam) {
                //如果拖入画布的组件有，myfetchparam，证明是自由布局或者轮播
                //则pageId,wfwfid,websiteId,更新为当前页面的值，防止老组件id不兼容
                const { pageId, wfwfid, websiteId } = this.$store.state.states.getDataPageIds
                rectAttr.options.appId = res.appId
                rectAttr.options.moduleId = res.moduleId
                rectAttr.options.myFetchParam.pageId = pageId
                rectAttr.options.myFetchParam.wfwfid = wfwfid
                rectAttr.options.myFetchParam.websiteId = websiteId
                rectAttr.options.myFetchParam.appId = res.appId
              }
              // 克隆的组件需要将原组件的子页面相关id清空
              // if (param.isClone) {
              //   delete rectAttr.options.detailPageId
              //   delete rectAttr.options.detailPageTemplateEncId
              //   delete rectAttr.options.listPageId
              //   delete rectAttr.options.listPageTemplateEncId
              // }
              // const params = {
              //   containerID: this.id,
              //   data: rectAttr
              // }
              // this.$store.dispatch(this.request_prefix + "/addElement", params)
              // if (!param.isClone) {
                // 如果是复制布局，则不激活组件
                // this.activateEv(this.id, rect_id, rectAttr.shape)
              // }
            }
          })
          .catch(err => console.log(err))
      }
      // 支持拖拽大小
      if (!rectAttr.options.top || rectAttr.options.top < 0) {
        rectAttr.options.top = 0
      }
      if (!rectAttr.options.left || rectAttr.options.left < 0) {
        rectAttr.options.left = 0
      }
      if (this.myid.hasOwnProperty("uid")) {
        rectAttr.options.filedMapping = {
          value: null,
          label: null,
          flag: false,
          checked: false
        }
      }
      //获取当前自动布局的宽高，修改拖入的组件的默认宽高，避免出现拖入的组件遮挡自动布局的情况
      if(this.request_prefix === "stage" && this.options.elementOptions.length === 0 && this.options.widthType === "px"){
        if((rectAttr.options.hasOwnProperty("widthType") && rectAttr.options.widthType === "px") || !rectAttr.options.hasOwnProperty("widthType")){
          if(rectAttr.options.width > this.options.width){
            rectAttr.options.width = this.options.width - 20
          }
        }
        if((rectAttr.options.hasOwnProperty("heightType") && rectAttr.options.heightType === "px") || !rectAttr.options.hasOwnProperty("heightType")){
          if(rectAttr.options.height > this.options.height){
            rectAttr.options.height = this.options.height - 20
          }
        }
      }

      const params = {
        ...this.myid,
        path: rectAttr.options.path,
        insertIndex: insertIndex,
        elementOptions: rectAttr.options
      }
      deepChangeUid(rectAttr)
      this.$store.dispatch(this.request_prefix + "/addAutoLayoutElement", params)
      // 获取拖拽组件所在布局
      let tempRect = this.getAttrById(this.$store.state[this.request_prefix], params, "autoLayout")
      let activeElement = tempRect.elementOptions[insertIndex]
      this.$addHistory({
        type: "add",
        stateType: "addAutoLayoutElement",
        payload: {
          ...this.myid,
          elementInAutoLayoutId: activeElement.elementInAutoLayoutId,
          path: rectAttr.options.path,
          index: insertIndex
        }
      })
      //默认选中组件
      this.activeEv(
        activeElement.elementInAutoLayoutId,
        activeElement.innerElement,
        activeElement
      )
    },
    // 获取鼠标在当前元素上的索引
    getInsertIndex(e) {
      let _this = this
      let top = Number(e.offsetY) //鼠标在当前元素上的位置
      let left = Number(e.offsetX)
      let _index = -1
      if (!e.target) return _index
      let targetPosition = e.target.getBoundingClientRect() // 当前元素位置
      let rowColDirection = _this.options?.rowColDirection
      if (rowColDirection === "vertical") {
        //垂直方向排列
        this.currentHalf = top / targetPosition.height < 0.5 ? false : true //超过元素高度一半显示在下方，否则显示在上方
      }
      if (rowColDirection === "horizon") {
        //水平方向排列
        this.currentHalf = left / targetPosition.width < 0.5 ? false : true // 超过元素宽度一半显示在后方，否则显示在前方
      }
      let parentNode = this.getParentNode(e.target, [])
      let targetVdr = this.getParentNode(e.target,[],'vdr') // 获取当前vdr元素
      if (this.startParent && targetVdr[0] === this.getParentNode(this.startParent[0],[],'vdr')[0]) {// 鼠标放到空隙中 没在元素上
        return this.insertIndex
      }
      if (this.startParent && this.startParent[0] !== parentNode[0]) { // 如果父级元素不同跨层级了禁止拖拽
        parentNode[0] = this.startParent[0] // 父级等于开始拖拽的父级
        if (this.getParentNode(targetVdr[0], [])[0] !== this.startParent[0]) {
          targetVdr = this.getParentNode(targetVdr[0],[],'vdr') // 目标元素取当前元素的父级
        }
      }
      if (parentNode.length === 0 || !targetVdr) {// 鼠标放到所在自动布局外层
      //   _index = _this.options.elementOptions.length
        return -1
      }
      // let parentPosition = parentNode[0].getBoundingClientRect()
      let allChild = parentNode[0]?.children[0]?.children
      if (!allChild) return -1
      for (var i = 0; i < allChild.length; i++) {
        if (allChild[i] === targetVdr[0]) {
          _index = i
          break
        }
      }
      if (rowColDirection === "vertical") {//垂直方向排列
        if (_index > this.activeIndex) {// 往下拖
          _index = top / targetPosition.height < 0.5 && _index > 0 ? _index - 1 : _index //超过元素高度一半保持原样，小于显示在当前元素上方
          this.currentHalf = true // 往下拖动时都显示在下方
        }
        if (_index < this.activeIndex) {// 往上拖
          _index = top / targetPosition.height < 0.5 ? _index : _index + 1 //超过元素高度一半显示在当前元素下方，小于保持原样
          this.currentHalf = false // 往上拖动时都显示在上方
        }
      }
      if (rowColDirection === "horizon") {//水平方向排列
        if (_index > this.activeIndex) {// 往右拖
          _index = left / targetPosition.width < 0.5 && _index > 0 ? _index - 1 : _index //超过元素宽度一半保持原样，小于显示在当前元素左边
          this.currentHalf = true // 往右拖动时都显示在右方
        }
        if (_index < this.activeIndex) {// 往左拖
          _index = left / targetPosition.width < 0.5 ? _index : _index + 1 //超过元素宽度一半显示在当前元素右方，小于保持原样
          this.currentHalf = false // 往左拖动时都显示在左方
        }
      }
      return _index + 1
    },
    getParentNode(e, res = [], className) {
      const parentNode = e?.parentNode
      let parentName = className ? className : "auto-layout-component"
      if (parentNode && parentNode.classList) {
        let elClasslist = parentNode.classList
        if ([].find.call(elClasslist, it => it === "myContainer")) {
          return []
        } else if ([].find.call(elClasslist, it => it === parentName)) {
          res.push(parentNode)
        }
        if (res.length > 0) {
          return res
        } else {
          return this.getParentNode(parentNode, res, className)
        }
      } else {
        return res
      }
    },
    dragoverLeaveEv(e) {
      sessionStorage.removeItem("dropOverCell")
      this.isDragover = false
      this.dragging = false
    },
    dragoverEv(e) {
      this.dragging = false
      let rectShape = localStorage.getItem("dragType")
      sessionStorage.setItem("dropOverCell", true)
      this.insertIndex = this.getInsertIndex(e)
      const disableShapes = [
        "cxPageLayout",
        // "emptyLayoutComponent",
        // "cxGaphic",
        // "cxSystemText",
        // "cxSystemNav",
        // "cxSystemSearch",
        // "swiperComponent",
        // "loginComponent",
        // "cxSystemLogin",
        // "cxUserPortraits",
        // "cxSystemAccordion",
        "cxPageLayoutComponent"
      ]
      if (this.myid.elementInLayoutId !== undefined) {
        disableShapes.push("cxAutoLayout") // 只允许拖入一个
      }
      if (!disableShapes.includes(rectShape)) {
        e.dataTransfer.dropEffect = "copy"
        this.isDragover = true
      } else {
        e.dataTransfer.dropEffect = "none"
      }
    },
    delElementEv(elementInAutoLayoutId, path) {
      let param = {
        ...this.myid,
        path,
        elementInAutoLayoutId
      }
      this.$store.commit("states/changeElementType", "cxAutoLayout")
      this.$store.dispatch(this.request_prefix + "/delAutoLayoutElement", param)
    },
    // 不需要了自动布局内的组件任何情况都能显示拖拽手柄
    checkResizable(rect) {
      let widthType = rect.hasOwnProperty("widthType") ? rect.widthType : "px"
      let heightType = rect.hasOwnProperty("heightType") ? rect.heightType : "px"
      if (widthType !== "px" && heightType !== "px") {
        return false
      }
      return true
    },
    resizestopEv(rect, elementInAutoLayoutId, path) {
      this.changeVGR(rect, "width", "height", elementInAutoLayoutId, path)
    },
    resizingEv: _throttle(function (rect, elementInAutoLayoutId, path) {
      this.changeVGR(rect, "width", "height", elementInAutoLayoutId, path)
    }, 100),
    //封装的修改布局组件中的组件的大小和位置的函数
    changeVGR(rect, change1, change2, elementInAutoLayoutId, path) {
      let param1 = {
        ...this.myid,
        path: path,
        option_name: [change1, change2],
        elementInAutoLayoutId: elementInAutoLayoutId,
        option_val: [rect[change1], rect[change2]]
      }
      this.$store.dispatch(this.request_prefix + "/changeAutoLayoutOptions", param1)
    },
    dragstartEv(e, rect) {
    },
    draggingEv: _throttle(function (rect, elementInAutoLayoutId, path, e) {
      // console.log('rect1 :>>',rect,this.dragging);
      if (!this.dragging) {
        if (e.target.classList && !e.target.classList.contains("vdr")) {
          let targetVdr = this.getParentNode(e.target, [], "vdr")[0]
          this.startParent = this.getParentNode(targetVdr, [])
        } else {
          this.startParent = this.getParentNode(e.target, [])
        }
        this.startRect = rect // 记录开始拖拽的位置
      }
      this.dragging = true
      this.isDragover = true
      this.insertIndex = this.getInsertIndex(e)
    }, 100),
    // 鼠标松开
    dragstopEv: _throttle(function (rect, elementInAutoLayoutId, path, e) {
      let insertIndex = this.getInsertIndex(e)
      this.insertIndex = null
      this.isDragover = false
      // if (this.dragging === false) return
      // if (!this.startRect || JSON.stringify(this.startRect) === JSON.stringify(rect)) return
      if (this.dragging === false || insertIndex < 1 || this.activeIndex < 0) return
      if (this.activeIndex + 1 === insertIndex) return
      // let tempRect = this.getAttrById.call(this, this.$store.state[this.request_prefix], {
      //   ...this.myid
      // }, "rect")
      let parentOptions = this.options
      let elementOptions = parentOptions?.elementOptions
      if (insertIndex > elementOptions?.length + 1) return
      let activeOptions = elementOptions.find(item=>item.elementInAutoLayoutId === elementInAutoLayoutId)
      elementOptions.splice(this.activeIndex, 1)
      // const params = {
      //   ...this.myid,
      //   path: path,
      //   insertIndex: insertIndex,
      //   elementOptions: activeOptions
      // }
      // this.$store.dispatch(this.request_prefix + "/addAutoLayoutElement", params)
      elementOptions.splice(insertIndex - 1 ,0 ,activeOptions)
      let index =  elementOptions.findIndex(item=>item.elementInAutoLayoutId === elementInAutoLayoutId)
      this.$changeOptionsEV(elementOptions, "elementOptions", false)
      this.activeEv(
        elementInAutoLayoutId,
        activeOptions.innerElement,
        activeOptions,
        index
      )
      this.dragging = false
    },100),
    checkHandles(rect) {
      if (rect.innerElement !== "cxAutoLayout") {
        return ["tl", "tm", "tr", "mr", "br", "bm", "bl", "ml"]
      }
      return ["tl", "tm", "tr", "mr", "br", "bm", "bl", "ml"]
    }
  }
}
</script>

<style scoped>
.auto-layout-component,
.auto-layout-content {
  position: relative;
  width: 100%;
  height: 100%;
  max-width: var(--maxWidth);
  min-width: var(--minWidth);
  max-height: var(--maxHeight);
  min-height: var(--minHeight);
}

.emptyColText {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  color: var(--thirdTextColor);
  font-size: 14px;
}

::v-deep .row-col-layout > .vdr {
  flex-shrink: 0; /* flex布局不改变子元素宽高 */
  position: relative;
  transform: none !important;
}
.isDrag-over .row-col-layout,
.row-col-layout .dragging {
  cursor: grab !important;
}
.isDrag-over .row-col-layout ::v-deep .dragging > div {
  opacity: 0.5 !important;
}
.row-col-layout.vertical > .vdr:last-child {
  margin-bottom: 0 !important;
}
.row-col-layout.horizon > .vdr:last-child {
  margin-right: 0 !important;
}

.vertical > .ghost::after {
  content: "";
  position: absolute;
  left: 0;
  width: 100%;
  height: 3px;
  background: var(--themeColor);
}
.vertical > .ghost.before::after {
  top: var(--custom-margin);
}
.vertical > .ghost.after::after {
  bottom: var(--custom-margin);
}
.vdr.before:first-child::after {/* 第一个元素前不要偏移值 */
  top: 0 !important;
  left: 0 !important;
}
.horizon > .ghost::after{
  content: "";
  position: absolute;
  top: 0;
  width: 3px;
  height: 100%;
  background: var(--themeColor);
}
.horizon > .ghost.before::after{
  left: var(--custom-margin);
}
.horizon > .ghost.after::after{
  right: var(--custom-margin);
}
.vdr.after:last-child::after {/* 最后一个元素后不要偏移值 */
  bottom: 0 !important;
  right: 0 !important;
}
.vdr_shade {
  cursor: grab !important;
}
.vdr.active > .auto-layout-component,
.vdr.vdr_hover > .auto-layout-component {
  outline: none !important;
}
</style>
